import AlertDialog from 'components/AlertDialog';
import { createContext, useCallback, useContext, useState } from 'react';

interface AlertState {
  title: string;
  body: React.ReactNode;
  buttonLabel?: string;
  onButtonClick?: () => void;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
}

interface AlertUpdater {
  (state: AlertState | null): void;
}

const AlertUpdaterContext = createContext<AlertUpdater>(() => {});

export const AlertProvider: React.FC = ({ children }) => {
  const [state, setState] = useState<AlertState | null>(null);
  return (
    <AlertUpdaterContext.Provider value={setState}>
      {children}
      {state != null && <AlertComponent state={state} updateState={setState} />}
    </AlertUpdaterContext.Provider>
  );
};

const AlertComponent = ({
  state,
  updateState,
}: {
  state: AlertState;
  updateState: AlertUpdater;
}) => {
  const [opened, setOpened] = useState(true);
  return (
    <AlertDialog
      isOpen={opened}
      onClose={() => {
        setOpened(false);
      }}
      onAfterClose={() => {
        updateState(null);
      }}
      {...state}
    />
  );
};

export function useAlert() {
  const updateAlert = useContext(AlertUpdaterContext);
  const showAlert = useCallback(
    (args: AlertState) => {
      updateAlert(args);
    },
    [updateAlert],
  );
  return showAlert;
}
